<template>
  <div>
    <v-layout wrap>
      <gat-edit
        v-model="textValue"
        :maxChars="50"
        label="Search"
        @input="doAutoSearch()"
        :size="$vuetify.breakpoint.xs ? 'xs12' : 'xs3'"
        hint="Search To (receiver), From (sender), Subject" />
      <gat-multi-select
        v-model="selectedLables"
        :items="props.labels"
        label="Labels"
        textFieldName="TEXT"
        codeFieldName="ID"
        :size="$vuetify.breakpoint.xs ? 'xs12' : 'xs3'"
        @input="doAutoSearch()">
      </gat-multi-select>
      <gat-edit
        dateEdit
        label="From date"
        v-model="fromDate"
        @input="doAutoSearch()"
        :size="$vuetify.breakpoint.xs ? 'xs6' : 'xs2'" />
      <gat-edit
        dateEdit
        label="To date"
        v-model="toDate"
        @input="doAutoSearch()"
        :size="$vuetify.breakpoint.xs ? 'xs6' : 'xs2'" />
      <gat-edit
        dataType="number"
        size="s"
        hide="phone"
        class="adjusright pl-3"
        v-model="maxRowCount"
        label="Max rows"
        @input="doAutoSearch()"
        :maxChars="4"
        :required="true" />
      <v-btn
        v-if="!autoSearch"
        class="searchBtn primary mr-3 mt-3 adjusright"
        @click="doSearch()"
        size="s"
        :disabled="!maxRowCount"
        >Search</v-btn
      >
    </v-layout>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface ILabel {
  ID: number;
  TEXT: string;
}

interface IEmailFilterParameter {
  dateTo: number;
  dateFrom: number;
  searchText: string;
  maxRowCount: number;
  selectedLables: number[];
}

const props = defineProps<{
  labels: ILabel[];
  maxRowCount: number;
  autoSearch?: boolean;
}>();

const emit = defineEmits<{
  (e: 'email-filter-parameters-changed', payload: IEmailFilterParameter): void;
}>();

const toDate = ref('');
const fromDate = ref('');
const textValue = ref('');
const selectedLables = ref<any>([]);
const maxRowCount = ref(props.maxRowCount);

const doSearch = () => {
  const emailFilterParameters: IEmailFilterParameter = {
    maxRowCount: maxRowCount.value || 1,
    selectedLables: selectedLables.value,
    dateTo: new Date(toDate.value).getTime(),
    searchText: textValue.value?.toLowerCase(),
    dateFrom: new Date(fromDate.value).getTime(),
  };
  emit('email-filter-parameters-changed', emailFilterParameters);
};

const doAutoSearch = () => {
  if (props.autoSearch) {
    doSearch();
  }
};
</script>
